import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@/hooks/useAuth'
import NotFound from '@/public/images/pageNotFound.svg'
import { getDefaultRouteForRole } from '@/utils/roleBasedRouting'

const PageNotFound = () => {
  const navigate = useNavigate()
  const { data: user } = useCurrentUser()

  const handleGoBack = useCallback(() => {
    // Check if we have history to go back to within the app
    const canGoBack =
      globalThis.history.state && globalThis.history.state.idx > 0

    if (canGoBack) {
      // Navigate to previous page
      navigate(-1)
    } else {
      // No previous page detected, navigate to default route
      const defaultRoute = getDefaultRouteForRole(user?.roles)
      navigate(defaultRoute, { replace: true })
    }
  }, [user, navigate])

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-16">
      <section className="w-full max-w-xl rounded-2xl bg-white p-10 text-center shadow-lg">
        <img
          src={NotFound}
          alt="Page Not Found"
          className="mx-auto h-[240px] w-[240px]"
        />
        <h2 className="text-md p-0 m-0 mt-2 font-bold text-gray-900">
          Page not found
        </h2>
        <p className=" text-md font-normal text-tertiary-600 m-0">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>
        <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            onClick={handleGoBack}
            variant="solid"
            color="primary"
            className="rounded-full px-4 py-3 text-sm"
          >
            Go back
          </Button>
        </div>
      </section>
    </main>
  )
}

export default PageNotFound
